export default __webpack_public_path__ + "static/media/c3.26758d1e.jpg";